module.exports = __webpack_public_path__ + "img/16581242_L.c3ab5206.png";